import { NgModule, Component, Input, EventEmitter, Output, Directive, ElementRef, Optional, HostListener, Injectable, ɵɵdefineInjectable, ɵɵinject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { throwError, EMPTY } from 'rxjs';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, select, Store } from '@ngrx/store';
import { takeWhile, map, catchError, mergeMap, filter } from 'rxjs/operators';
import { __assign, __values } from 'tslib';
import { RouterModule } from '@angular/router';
import { NgControl, FormGroup } from '@angular/forms';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/opm-core.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OpmCoreModule = /** @class */ (function () {
    function OpmCoreModule() {
    }
    OpmCoreModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule
                    ]
                },] }
    ];
    return OpmCoreModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/components/breadcrumbs/breadcrumbs.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BreadcrumbsComponent = /** @class */ (function () {
    function BreadcrumbsComponent() {
    }
    /**
     * @return {?}
     */
    BreadcrumbsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    BreadcrumbsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'opm-breadcrumbs',
                    template: "<ng-container *ngIf=\"(breadcrumbs | async) && (breadcrumbs | async).length > 0\">\n    <!-- <aside id=\"breadcrumbs\">\n      <label>\n        You are here:\n      </label>\n      <div>\n        <ng-container *ngFor=\"let breadcrumb of breadcrumbs | async as breadcrumbsArray; let i = index;\">\n          <a [routerLink]=\"breadcrumb.routeParams\" *ngIf=\"i != breadcrumbsArray.length - 1\">{{breadcrumb.name}}</a>\n          <span *ngIf=\"i == breadcrumbsArray.length - 1\" class=\"current\">{{breadcrumb.name}}</span>\n        </ng-container>\n  \n      </div>\n    </aside> -->\n    <nav class=\"usa-breadcrumb\" aria-label=\"Breadcrumbs\">\n        <ol class=\"usa-breadcrumb__list\">\n            <ng-container *ngFor=\"let breadcrumb of breadcrumbs | async as breadcrumbsArray; let i = index;\">\n                <li class=\"usa-breadcrumb__list-item\" *ngIf=\"i != breadcrumbsArray.length - 1\">\n                    <a [routerLink]=\"breadcrumb.routeParams\" class=\"usa-breadcrumb__link\">\n                        <span>{{breadcrumb.name}}</span>\n                    </a>\n                </li>\n\n                <li class=\"usa-breadcrumb__list-item usa-current\" aria-current=\"page\" *ngIf=\"i == breadcrumbsArray.length - 1\">\n                    <span>{{breadcrumb.name}}</span>\n                </li>\n            </ng-container>\n        </ol>\n    </nav>\n  </ng-container>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BreadcrumbsComponent.ctorParameters = function () { return []; };
    BreadcrumbsComponent.propDecorators = {
        breadcrumbs: [{ type: Input }]
    };
    return BreadcrumbsComponent;
}());
if (false) {
    /** @type {?} */
    BreadcrumbsComponent.prototype.breadcrumbs;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/state/actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthActions;
(function (AuthActions) {
    AuthActions.getToken = createAction('[Root] GetToken');
    AuthActions.getTokenSuccess = createAction('[Root] GetTokenSuccess', (/**
     * @param {?} token
     * @return {?}
     */
    function (token) { return ({ token: token }); }));
    AuthActions.getTokenFailure = createAction('[Root] GetTokenFailure', (/**
     * @param {?} message
     * @return {?}
     */
    function (message) { return ({ message: message }); }));
    AuthActions.showModalLogin = createAction('[Root] ShowModalLogin', (/**
     * @param {?} html
     * @return {?}
     */
    function (html) { return ({ html: html }); }));
    AuthActions.postModalLogin = createAction('[Root] PostModalLogin', (/**
     * @param {?} credentials
     * @return {?}
     */
    function (credentials) { return ({ credentials: credentials }); }));
    AuthActions.postModalLoginSuccess = createAction('[Root] PostModalLoginSuccess', (/**
     * @param {?} loginSuccess
     * @return {?}
     */
    function (loginSuccess) { return ({ loginSuccess: loginSuccess }); }));
    AuthActions.postModalLoginFailure = createAction('[Root] PostModalLoginFailure', (/**
     * @param {?} message
     * @return {?}
     */
    function (message) { return ({ message: message }); }));
    AuthActions.resetSessionExtended = createAction('[Root] ResetSessionExtended');
    AuthActions.getLoggedInStatus = createAction('[Root] GetLoggedInStatus');
    AuthActions.getLoggedInStatusSuccess = createAction('[Root] GetLoggedInStatusSuccess');
    AuthActions.getLoggedInStatusFailure = createAction('[Root] GetLoggedInStatusFailure');
})(AuthActions || (AuthActions = {}));
var ShellActions;
(function (ShellActions) {
    ShellActions.setProcessing = createAction('[Root] Set Processing', (/**
     * @param {?} processing
     * @return {?}
     */
    function (processing) { return ({ processing: processing }); }));
    ShellActions.setSuccessMessage = createAction('[Root] Set Success Message', props());
    ShellActions.setErrorMessage = createAction('[Root] Set Error Message', props());
    ShellActions.requestNavigation = createAction('[Root] Request Navigation Event', props());
    ShellActions.setBreadcrumbs = createAction('[Root] Set Breadcrumbs', (/**
     * @param {?} breadcrumbs
     * @return {?}
     */
    function (breadcrumbs) { return ({ breadcrumbs: breadcrumbs }); }));
    ShellActions.setServerErrors = createAction('[Root] Set Server Errors', (/**
     * @param {?} errors
     * @return {?}
     */
    function (errors) { return ({ errors: errors }); }));
})(ShellActions || (ShellActions = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/state/state.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ShellState() { }
if (false) {
    /** @type {?} */
    ShellState.prototype.processing;
    /** @type {?} */
    ShellState.prototype.errorMessage;
    /** @type {?} */
    ShellState.prototype.serverErrors;
    /** @type {?} */
    ShellState.prototype.successMessage;
    /** @type {?} */
    ShellState.prototype.auth;
    /** @type {?} */
    ShellState.prototype.loginModal;
    /** @type {?} */
    ShellState.prototype.navigationRequestParams;
    /** @type {?} */
    ShellState.prototype.breadcrumbs;
}
/** @type {?} */
var initialState = {
    processing: false,
    errorMessage: '',
    serverErrors: null,
    successMessage: '',
    auth: {
        authenticated: false,
        token: '',
        user: {
            email: '',
            fullName: '',
            roles: [],
            activeDirectoryRoles: [],
            userName: '',
            userId: 0
        },
        sessionExtended: false,
    },
    loginModal: {
        show: false,
        html: ''
    },
    navigationRequestParams: { routeParams: [] },
    breadcrumbs: []
};
/**
 * @record
 */
function AuthState() { }
if (false) {
    /** @type {?} */
    AuthState.prototype.authenticated;
    /** @type {?} */
    AuthState.prototype.token;
    /** @type {?} */
    AuthState.prototype.user;
    /** @type {?} */
    AuthState.prototype.sessionExtended;
}
/**
 * @record
 */
function UserState() { }
if (false) {
    /** @type {?} */
    UserState.prototype.userId;
    /** @type {?} */
    UserState.prototype.userName;
    /** @type {?} */
    UserState.prototype.fullName;
    /** @type {?} */
    UserState.prototype.email;
    /** @type {?} */
    UserState.prototype.roles;
    /** @type {?} */
    UserState.prototype.activeDirectoryRoles;
}
/**
 * @record
 */
function LoginModal() { }
if (false) {
    /** @type {?} */
    LoginModal.prototype.show;
    /** @type {?} */
    LoginModal.prototype.html;
}
/**
 * @record
 */
function LoginState() { }
if (false) {
    /** @type {?} */
    LoginState.prototype.username;
    /** @type {?} */
    LoginState.prototype.password;
}
/**
 * @record
 */
function RootState() { }
if (false) {
    /** @type {?} */
    RootState.prototype.shell;
    /** @type {?} */
    RootState.prototype.routes;
}
/**
 * @record
 */
function State() { }
if (false) {
    /** @type {?} */
    State.prototype.root;
}
/**
 * @record
 */
function RouterStateUrl() { }
if (false) {
    /** @type {?} */
    RouterStateUrl.prototype.url;
    /** @type {?} */
    RouterStateUrl.prototype.queryParams;
    /** @type {?} */
    RouterStateUrl.prototype.params;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/state/reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var routeParams = _a.routeParams, queryParams = _a.queryParams;
    return (__assign({}, state, { navigationRequestParams: {
            routeParams: routeParams,
            queryParams: queryParams
        } }));
}, ɵ1 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var breadcrumbs = _a.breadcrumbs;
    return (__assign({}, state, { breadcrumbs: breadcrumbs }));
}, ɵ2 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var processing = _a.processing;
    return (__assign({}, state, { processing: processing }));
}, ɵ3 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var message = _a.message;
    return (__assign({}, state, { errorMessage: message }));
}, ɵ4 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var errors = _a.errors;
    return (__assign({}, state, { serverErrors: errors }));
}, ɵ5 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var message = _a.message;
    return (__assign({}, state, { successMessage: message }));
}, ɵ6 = /**
 * @param {?} state
 * @return {?}
 */
function (state) { return (__assign({}, state, { processing: true })); }, ɵ7 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var token = _a.token;
    return (__assign({}, state, { auth: token, processing: false }));
}, ɵ8 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var message = _a.message;
    return (__assign({}, state, { errorMessage: message, processing: false }));
}, ɵ9 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var html = _a.html;
    return (__assign({}, state, { loginModal: { show: true, html: html } }));
}, ɵ10 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var credentials = _a.credentials;
    return (__assign({}, state, { processing: true }));
}, ɵ11 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var loginSuccess = _a.loginSuccess;
    return (__assign({}, state, { processing: false, auth: __assign({}, state.auth, { sessionExtended: loginSuccess }) }));
}, ɵ12 = /**
 * @param {?} state
 * @param {?} __1
 * @return {?}
 */
function (state, _a) {
    var message = _a.message;
    return (__assign({}, state, { errorMessage: message, processing: false }));
}, ɵ13 = /**
 * @param {?} state
 * @return {?}
 */
function (state) { return (__assign({}, state, { auth: __assign({}, state.auth, { sessionExtended: false }) })); }, ɵ14 = /**
 * @param {?} state
 * @return {?}
 */
function (state) { return (__assign({}, state, { auth: __assign({}, state.auth, { authenticated: true }) })); }, ɵ15 = /**
 * @param {?} state
 * @return {?}
 */
function (state) { return (__assign({}, state, { auth: __assign({}, state.auth, { authenticated: false }) })); };
/** @type {?} */
var shellReducer = createReducer(initialState, on(ShellActions.requestNavigation, (ɵ0)), on(ShellActions.setBreadcrumbs, (ɵ1)), on(ShellActions.setProcessing, (ɵ2)), on(ShellActions.setErrorMessage, (ɵ3)), on(ShellActions.setServerErrors, (ɵ4)), on(ShellActions.setSuccessMessage, (ɵ5)), on(AuthActions.getToken, (ɵ6)), on(AuthActions.getTokenSuccess, (ɵ7)), on(AuthActions.getTokenFailure, (ɵ8)), on(AuthActions.showModalLogin, (ɵ9)), on(AuthActions.postModalLogin, (ɵ10)), on(AuthActions.postModalLoginSuccess, (ɵ11)), on(AuthActions.postModalLoginFailure, (ɵ12)), on(AuthActions.resetSessionExtended, (ɵ13)), on(AuthActions.getLoggedInStatusSuccess, (ɵ14)), on(AuthActions.getLoggedInStatusFailure, (ɵ15)));
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    return shellReducer(state, action);
}
var RootSelectors;
(function (RootSelectors) {
    RootSelectors.getRootState = createFeatureSelector('root');
    RootSelectors.getShellState = createSelector(RootSelectors.getRootState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        return state ? state.shell : undefined;
    }));
    // createFeatureSelector<State, fromShell.ShellState>('shell');
    RootSelectors.getProcessing = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.processing; }));
    RootSelectors.getErrorMessage = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.errorMessage; }));
    RootSelectors.getServerErrors = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.serverErrors; }));
    RootSelectors.getSuccessMessage = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.successMessage; }));
    RootSelectors.getBreadcrumbs = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.breadcrumbs; }));
    RootSelectors.navigationRequestParams = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.navigationRequestParams; }));
    RootSelectors.getAuthenticated = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.auth.authenticated; }));
    RootSelectors.getUser = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.auth.user; }));
    RootSelectors.getSessionExtended = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.auth.sessionExtended; }));
    RootSelectors.getShowModalLogin = createSelector(RootSelectors.getShellState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.loginModal; }));
    RootSelectors.getRouterState = createSelector(RootSelectors.getRootState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.routes.state; }));
    RootSelectors.getRouterParams = createSelector(RootSelectors.getRouterState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.params; }));
    RootSelectors.getRouterQueryParams = createSelector(RootSelectors.getRouterState, (/**
     * @param {?} state
     * @return {?}
     */
    function (state) { return state.queryParams; }));
})(RootSelectors || (RootSelectors = {}));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/components/loading-overlay/loading-overlay.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingOverlayComponent = /** @class */ (function () {
    function LoadingOverlayComponent(store) {
        this.store = store;
        this.componentActive = true;
    }
    /**
     * @return {?}
     */
    LoadingOverlayComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.processing = this.store.pipe(select(RootSelectors.getProcessing), takeWhile((/**
         * @return {?}
         */
        function () { return _this.componentActive; })));
    };
    /**
     * @return {?}
     */
    LoadingOverlayComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.componentActive = false;
    };
    LoadingOverlayComponent.decorators = [
        { type: Component, args: [{
                    selector: 'opm-loading-overlay',
                    template: "<div class=\"loadingGraphic\" *ngIf=\"processing | async\"></div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    LoadingOverlayComponent.ctorParameters = function () { return [
        { type: Store }
    ]; };
    return LoadingOverlayComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoadingOverlayComponent.prototype.componentActive;
    /** @type {?} */
    LoadingOverlayComponent.prototype.processing;
    /**
     * @type {?}
     * @private
     */
    LoadingOverlayComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/components/user-summary/user-summary.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserSummaryComponent = /** @class */ (function () {
    function UserSummaryComponent() {
        this.loggedOut = new EventEmitter();
    }
    /**
     * @return {?}
     */
    UserSummaryComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    UserSummaryComponent.prototype.logout = /**
     * @return {?}
     */
    function () {
        this.loggedOut.emit();
    };
    UserSummaryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'opm-user-summary',
                    template: "<div id=\"currentUser\" *ngIf=\"user\">\n    <div id=\"currentUserInner\" style=\"display: flex; flex-direction: column;\">\n      <div style=\"display: flex\">\n        <span id=\"userIcon\" class=\"image\">User Icon</span>\n        <span id=\"userName\">{{user.fullName}}</span>\n        <span id=\"userRoles\" [matTooltip]=\"user.roles.join('\\n\\n')\">( {{user.roles.length}} Roles )</span>\n        <span>&nbsp; - &nbsp;</span>\n        <a (click)=\"logout()\">Logout</a>\n      </div>\n    </div>\n  </div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    UserSummaryComponent.ctorParameters = function () { return []; };
    UserSummaryComponent.propDecorators = {
        user: [{ type: Input }],
        loggedOut: [{ type: Output }]
    };
    return UserSummaryComponent;
}());
if (false) {
    /** @type {?} */
    UserSummaryComponent.prototype.user;
    /** @type {?} */
    UserSummaryComponent.prototype.loggedOut;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/directives/date-picker.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DatePickerDirective = /** @class */ (function () {
    function DatePickerDirective(el, control) {
        var _this = this;
        this.el = el;
        this.control = control;
        this.value = '';
        this.dateChange = new EventEmitter();
        /** @type {?} */
        var _options = this.options || {};
        /** @type {?} */
        var _defaultOptions = {
            onSelect: (/**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                _this.value = value;
                _this.dateChange.next(value);
                console.log("datepicker onselect called", value);
                _this.control.control.setValue(value);
                _this.control.control.markAsDirty();
            }),
            changeYear: true,
            changeMonth: true,
            maxDate: "+3y",
            minDate: new Date(1900, 0, 0),
            yearRange: "1900:+3"
        };
        jQuery(this.el.nativeElement).datepicker(_defaultOptions).datepicker('setDate', this.value);
    }
    DatePickerDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[datePicker]'
                },] }
    ];
    /** @nocollapse */
    DatePickerDirective.ctorParameters = function () { return [
        { type: ElementRef, decorators: [{ type: Optional }] },
        { type: NgControl, decorators: [{ type: Optional }] }
    ]; };
    DatePickerDirective.propDecorators = {
        value: [{ type: Input }],
        dateChange: [{ type: Output }],
        options: [{ type: Input, args: ['datePicker',] }]
    };
    return DatePickerDirective;
}());
if (false) {
    /** @type {?} */
    DatePickerDirective.prototype.value;
    /** @type {?} */
    DatePickerDirective.prototype.dateChange;
    /** @type {?} */
    DatePickerDirective.prototype.options;
    /**
     * @type {?}
     * @private
     */
    DatePickerDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    DatePickerDirective.prototype.control;
}
var DatePickerOptions = /** @class */ (function () {
    function DatePickerOptions() {
    }
    return DatePickerOptions;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/components/base-components/validatable-base/validatable-base.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ValidatableBaseComponent = /** @class */ (function () {
    function ValidatableBaseComponent() {
        this.componentActive = true;
        this.arraySubscriptions = [];
    }
    /**
     * @return {?}
     */
    ValidatableBaseComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    ValidatableBaseComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.componentActive = false;
        this.arraySubscriptions.forEach((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s.unsubscribe(); }));
    };
    /**
     * @protected
     * @return {?}
     */
    ValidatableBaseComponent.prototype.subscribeValidationMessages = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        var _loop_1 = function (key) {
            /** @type {?} */
            var control = this_1.formGroup.get(key);
            if (control != null) {
                control.valueChanges.pipe(takeWhile((/**
                 * @return {?}
                 */
                function () { return _this.componentActive; }))).subscribe((/**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) { return _this.setMessage(key, key, control); }));
            }
            else {
                console.log('control: ' + key + ' not found');
            }
        };
        var this_1 = this;
        for (var key in this.activeValidationMessages) {
            _loop_1(key);
        }
    };
    /**
     * @param {?} validationTemplateKey
     * @param {?} activeMessageKey
     * @param {?} control
     * @return {?}
     */
    ValidatableBaseComponent.prototype.setMessage = /**
     * @param {?} validationTemplateKey
     * @param {?} activeMessageKey
     * @param {?} control
     * @return {?}
     */
    function (validationTemplateKey, activeMessageKey, control) {
        var _this = this;
        this.activeValidationMessages[activeMessageKey] = '';
        if (control instanceof FormGroup) {
            if (control.status == "INVALID") {
                this.activeValidationMessages[activeMessageKey] = Object.keys(this.validationMessages[validationTemplateKey].validators).map((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) { return _this.validationMessages[validationTemplateKey].validators[key].message; })).join(' ');
            }
        }
        else {
            if (control.errors) {
                try {
                    this.activeValidationMessages[activeMessageKey] = Object.keys(control.errors).map((/**
                     * @param {?} key
                     * @return {?}
                     */
                    function (key) { return _this.validationMessages[validationTemplateKey].validators[key].message; })).join(' / ');
                }
                catch (e) {
                    console.log('validationTemplateKey ' + validationTemplateKey);
                }
            }
        }
    };
    /**
     * @param {?} action
     * @return {?}
     */
    ValidatableBaseComponent.prototype.updateEnabledValidators = /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        for (var controlKey in this.validationMessages) {
            /** @type {?} */
            var control = this.formGroup.get(controlKey);
            if (control != null) {
                control.setValidators(null);
                this.updateControlValidators(action, controlKey, control);
            }
            else {
                /** @type {?} */
                var formArrayName = this.validationMessages[controlKey].formArrayName;
                /** @type {?} */
                var arrayGroup = (/** @type {?} */ ((this.formGroup.get(formArrayName))));
                if (arrayGroup != null) {
                    for (var index = 0; index < arrayGroup.length; index++) {
                        /** @type {?} */
                        var arrayFormControlName = controlKey.replace(formArrayName + '.', '');
                        /** @type {?} */
                        var arrayControl = arrayGroup.at(index).get(arrayFormControlName);
                        /** @type {?} */
                        var arrayFormControlKey = formArrayName + "." + index + "." + arrayFormControlName;
                        this.activeValidationMessages[arrayFormControlKey] = '';
                        this.updateControlValidators(action, controlKey, arrayControl);
                    }
                }
            }
        }
    };
    /**
     * @param {?} action
     * @param {?} controlKey
     * @param {?} control
     * @return {?}
     */
    ValidatableBaseComponent.prototype.updateControlValidators = /**
     * @param {?} action
     * @param {?} controlKey
     * @param {?} control
     * @return {?}
     */
    function (action, controlKey, control) {
        /** @type {?} */
        var validators = [];
        for (var validatorKey in this.validationMessages[controlKey].validators) {
            if (validatorKey !== 'formArrayName') {
                /** @type {?} */
                var actions = (/** @type {?} */ ((this.validationMessages[controlKey].validators[validatorKey].actions)));
                if (actions.indexOf(action) > -1) {
                    if (this.validationMessages[controlKey].validators[validatorKey].validator !== undefined)
                        validators.push(this.validationMessages[controlKey].validators[validatorKey].validator);
                }
            }
        }
        if (validators.length > 0)
            control.setValidators(validators);
        else
            control.setValidators([]);
        control.updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    ValidatableBaseComponent.prototype.canDeactivate = /**
     * @return {?}
     */
    function () {
        return !this.formGroup.dirty;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ValidatableBaseComponent.prototype.unloadNotification = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (!this.canDeactivate()) {
            $event.returnValue = "This message is displayed to the user in IE and Edge when they navigate without using Angular routing (type another URL/close the browser/etc)";
        }
    };
    ValidatableBaseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'opm-validatable-base',
                    template: "<p>validatable-base works!</p>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ValidatableBaseComponent.ctorParameters = function () { return []; };
    ValidatableBaseComponent.propDecorators = {
        unloadNotification: [{ type: HostListener, args: ['window:beforeunload', ['$event'],] }]
    };
    return ValidatableBaseComponent;
}());
if (false) {
    /**
     * @type {?}
     * @protected
     */
    ValidatableBaseComponent.prototype.formGroup;
    /**
     * @type {?}
     * @protected
     */
    ValidatableBaseComponent.prototype.validationMessages;
    /** @type {?} */
    ValidatableBaseComponent.prototype.activeValidationMessages;
    /**
     * @type {?}
     * @protected
     */
    ValidatableBaseComponent.prototype.componentActive;
    /**
     * @type {?}
     * @protected
     */
    ValidatableBaseComponent.prototype.arraySubscriptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/opm-shared.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OpmSharedModule = /** @class */ (function () {
    function OpmSharedModule() {
    }
    OpmSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [BreadcrumbsComponent, LoadingOverlayComponent, UserSummaryComponent, DatePickerDirective, ValidatableBaseComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        MatTooltipModule,
                    ],
                    exports: [
                        BreadcrumbsComponent,
                        LoadingOverlayComponent,
                        UserSummaryComponent,
                        ValidatableBaseComponent,
                        DatePickerDirective
                    ]
                },] }
    ];
    return OpmSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/models/breadcrumb.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Breadcrumb() { }
if (false) {
    /** @type {?} */
    Breadcrumb.prototype.name;
    /** @type {?} */
    Breadcrumb.prototype.routeParams;
    /** @type {?|undefined} */
    Breadcrumb.prototype.queryParams;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/models/validation-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ConditonalValidator() { }
if (false) {
    /** @type {?} */
    ConditonalValidator.prototype.message;
    /** @type {?} */
    ConditonalValidator.prototype.actions;
    /** @type {?|undefined} */
    ConditonalValidator.prototype.validator;
}
/**
 * @record
 */
function IndexedConditonalValidator() { }
/**
 * @record
 */
function ConditonalValidatorGroup() { }
if (false) {
    /** @type {?|undefined} */
    ConditonalValidatorGroup.prototype.formArrayName;
    /** @type {?} */
    ConditonalValidatorGroup.prototype.validators;
}
/**
 * @record
 */
function IndexedConditonalValidatorGroup() { }

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/models/core-libs.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CorePageBannerOptions() { }
if (false) {
    /** @type {?} */
    CorePageBannerOptions.prototype.title;
    /** @type {?} */
    CorePageBannerOptions.prototype.type;
}
/**
 * @record
 */
function CorePageBanner() { }
if (false) {
    /** @type {?} */
    CorePageBanner.prototype.bannerTypes;
    /**
     * @param {?} message
     * @param {?} options
     * @return {?}
     */
    CorePageBanner.prototype.loadResponse = function (message, options) { };
}
/**
 * @record
 */
function CoreLib() { }
if (false) {
    /** @type {?} */
    CoreLib.prototype.pageBanner;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/models/guid.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// http://stackoverflow.com/questions/26501688/a-typescript-guid-class
// @dynamic
var  
// http://stackoverflow.com/questions/26501688/a-typescript-guid-class
// @dynamic
Guid = /** @class */ (function () {
    function Guid() {
    }
    /**
     * @return {?}
     */
    Guid.newGuid = /**
     * @return {?}
     */
    function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (/**
         * @param {?} c
         * @return {?}
         */
        function (c) {
            /** @type {?} */
            var r = Math.random() * 16 | 0;
            /** @type {?} */
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }));
    };
    Object.defineProperty(Guid, "empty", {
        get: /**
         * @return {?}
         */
        function () {
            return '00000000-0000-0000-0000-000000000000';
        },
        enumerable: true,
        configurable: true
    });
    return Guid;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-shared/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/state/custom-serializer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomSerializer = /** @class */ (function () {
    function CustomSerializer() {
    }
    /**
     * @param {?} routerState
     * @return {?}
     */
    CustomSerializer.prototype.serialize = /**
     * @param {?} routerState
     * @return {?}
     */
    function (routerState) {
        var e_1, _a;
        /** @type {?} */
        var route = routerState.root;
        /** @type {?} */
        var params = {};
        while (route.firstChild) {
            try {
                for (var _b = (e_1 = void 0, __values(route.children)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var childRoute = _c.value;
                    for (var paramKey in childRoute.params) {
                        params[paramKey] = childRoute.params[paramKey];
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            route = route.children[route.children.length - 1];
        }
        var url = routerState.url, queryParams = routerState.root.queryParams;
        // Only return an object including the URL, params and query params
        // instead of the entire snapshot
        return { url: url, params: params, queryParams: queryParams };
    };
    return CustomSerializer;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/services/account.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccountService = /** @class */ (function () {
    function AccountService(http) {
        this.http = http;
    }
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    AccountService.prototype.createUserStateFromToken = /**
     * @private
     * @param {?} token
     * @return {?}
     */
    function (token) {
        /** @type {?} */
        var helper = new JwtHelperService();
        /** @type {?} */
        var decodedToken = helper.decodeToken(token);
        /** @type {?} */
        var rolesValue = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        /** @type {?} */
        var adRolesValue = decodedToken['OPM-AD-Group'];
        /** @type {?} */
        var roles = rolesValue instanceof Array ? rolesValue : [rolesValue];
        /** @type {?} */
        var adRoles = adRolesValue instanceof Array ? adRolesValue : [adRolesValue];
        /** @type {?} */
        var payload = {
            authenticated: true,
            token: decodedToken,
            user: {
                email: decodedToken['Email'],
                fullName: decodedToken['FullName'],
                userName: decodedToken["UserName"],
                userId: decodedToken["UserId"],
                roles: roles,
                activeDirectoryRoles: adRoles
            },
            sessionExtended: false,
        };
        return payload;
    };
    /**
     * @return {?}
     */
    AccountService.prototype.getUserFromToken = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var requestUrl = baseUrl + "/account/gettoken";
        return this.http.get(requestUrl)
            .pipe(map((/**
         * @param {?} token
         * @return {?}
         */
        function (token) {
            return _this.createUserStateFromToken(token.token);
        })), catchError((/**
         * @param {?} httpError
         * @return {?}
         */
        function (httpError) { return _this.handleError(httpError); })));
    };
    /**
     * @param {?} username
     * @param {?} password
     * @return {?}
     */
    AccountService.prototype.login = /**
     * @param {?} username
     * @param {?} password
     * @return {?}
     */
    function (username, password) {
        var _this = this;
        /** @type {?} */
        var requestUrl = baseUrl + "/account/LoginAsync?showmodal=true";
        /** @type {?} */
        var params = { UserName: username, Password: password, apiLogin: '1' };
        return this.http.post(requestUrl, params)
            .pipe(map((/**
         * @param {?} token
         * @return {?}
         */
        function (token) {
            return true;
        })), catchError((/**
         * @param {?} httpError
         * @return {?}
         */
        function (httpError) { return _this.handleError(httpError); })));
    };
    /**
     * @param {?} httpError
     * @return {?}
     */
    AccountService.prototype.handleError = /**
     * @param {?} httpError
     * @return {?}
     */
    function (httpError) {
        /** @type {?} */
        var errorMessage = "An unknown error occurred while submitting the request.";
        if (httpError.error && httpError.error.message) {
            errorMessage = httpError.error.message;
        }
        //core.pageBanner.loadResponse(errorMessage, { title: "Error occurred", type: core.pageBanner.bannerTypes.error });
        return throwError(httpError);
    };
    AccountService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AccountService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ AccountService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AccountService_Factory() { return new AccountService(ɵɵinject(HttpClient)); }, token: AccountService, providedIn: "root" });
    return AccountService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AccountService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/state/effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ShellEffects = /** @class */ (function () {
    function ShellEffects(actions$, accountService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.accountService = accountService;
        this.store = store;
        this.getToken$ = createEffect((/**
         * @return {?}
         */
        function () { return _this.actions$.pipe(ofType(AuthActions.getToken), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        function (action) { return _this.accountService.getUserFromToken().pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            return AuthActions.getTokenSuccess(response);
        })), catchError((/**
         * @param {?} err
         * @return {?}
         */
        function (err) { return [AuthActions.getTokenFailure(err)]; }))); }))); }));
        this.modealLogin$ = createEffect((/**
         * @return {?}
         */
        function () {
            return _this.actions$.pipe(ofType(AuthActions.postModalLogin), mergeMap((/**
             * @param {?} action
             * @return {?}
             */
            function (action) { return _this.accountService.login(action.credentials.username, action.credentials.password).pipe(map((/**
             * @param {?} response
             * @return {?}
             */
            function (response) {
                return AuthActions.postModalLoginSuccess(response);
            })), catchError((/**
             * @param {?} err
             * @return {?}
             */
            function (err) { return [AuthActions.postModalLoginFailure(err)]; }))); })));
        }));
    }
    ShellEffects.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ShellEffects.ctorParameters = function () { return [
        { type: Actions },
        { type: AccountService },
        { type: Store }
    ]; };
    return ShellEffects;
}());
if (false) {
    /** @type {?} */
    ShellEffects.prototype.getToken$;
    /** @type {?} */
    ShellEffects.prototype.modealLogin$;
    /**
     * @type {?}
     * @private
     */
    ShellEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    ShellEffects.prototype.accountService;
    /**
     * @type {?}
     * @private
     */
    ShellEffects.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/services/app-load.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppLoadService = /** @class */ (function () {
    function AppLoadService(store) {
        this.store = store;
    }
    /**
     * @return {?}
     */
    AppLoadService.prototype.getUserToken = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.store.dispatch(AuthActions.getToken());
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.store.pipe(select(RootSelectors.getAuthenticated), filter((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x; }))).subscribe((/**
             * @param {?} token
             * @return {?}
             */
            function (token) {
                resolve(token);
            }), (
            // subscription delivered a valid result
            /**
             * @param {?} error
             * @return {?}
             */
            function (// subscription delivered a valid result
            error) {
                reject(error);
            })); // subscription encountered an error
        }));
    };
    AppLoadService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AppLoadService.ctorParameters = function () { return [
        { type: Store }
    ]; };
    /** @nocollapse */ AppLoadService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AppLoadService_Factory() { return new AppLoadService(ɵɵinject(Store)); }, token: AppLoadService, providedIn: "root" });
    return AppLoadService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AppLoadService.prototype.store;
}
/**
 * @param {?} appLoadService
 * @return {?}
 */
function getUserToken(appLoadService) {
    return (/**
     * @return {?}
     */
    function () { return appLoadService.getUserToken(); });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/services/format-date.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormatDateService = /** @class */ (function () {
    function FormatDateService() {
        this.datePipe = new DatePipe('en-US'); // Use your own locale
    }
    /**
     * @param {?} date
     * @return {?}
     */
    FormatDateService.prototype.transform = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return this.datePipe.transform(date, 'MM/dd/yyyy');
    };
    FormatDateService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FormatDateService.ctorParameters = function () { return []; };
    /** @nocollapse */ FormatDateService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FormatDateService_Factory() { return new FormatDateService(); }, token: FormatDateService, providedIn: "root" });
    return FormatDateService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    FormatDateService.prototype.datePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/opm-core/interceptors/http-auth.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor(store) {
        this.store = store;
        this.counter = 0;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    AuthInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var _this = this;
        return next.handle(req).pipe(catchError((/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            if (err instanceof HttpErrorResponse) {
                _this.store.dispatch(ShellActions.setProcessing(false));
                if (err.status === 401 || (err.error && err.error.loginForm)) {
                    if (err.error && err.error.loginForm) {
                        _this.store.dispatch(AuthActions.showModalLogin(err.error.loginForm.Result || err.error.loginForm.result));
                    }
                    return EMPTY;
                }
                else if (err.status === 400) {
                    if (!err.error.hasOwnProperty('custom')) {
                        _this.store.dispatch(ShellActions.setErrorMessage({ message: 'There was an error with your request.  Please see the errors below:', source: 'Bad Request' }));
                    }
                    return throwError(err);
                }
                else if (err.status === 0) {
                    /** @type {?} */
                    var friendlyError = __assign({}, err, { error: 'Network connection dropped.  Please try again.' });
                    return throwError(friendlyError);
                }
                else {
                    /** @type {?} */
                    var friendlyError = __assign({}, err, { error: 'An error occurred' });
                    return throwError(friendlyError);
                }
            }
        })));
    };
    AuthInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AuthInterceptor.ctorParameters = function () { return [
        { type: Store }
    ]; };
    return AuthInterceptor;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthInterceptor.prototype.counter;
    /**
     * @type {?}
     * @private
     */
    AuthInterceptor.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: opm-ng-core.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AppLoadService, AuthActions, AuthInterceptor, BreadcrumbsComponent, CustomSerializer, DatePickerDirective, DatePickerOptions, FormatDateService, Guid, LoadingOverlayComponent, OpmCoreModule, OpmSharedModule, RootSelectors, ShellActions, ShellEffects, UserSummaryComponent, ValidatableBaseComponent, getUserToken, initialState, reducer, ShellActions as ɵa, AuthActions as ɵb, AccountService as ɵc };
//# sourceMappingURL=opm-ng-core.js.map
